<template>
    <div
        class="slider"
        ref="slider"
    >
        <div
            class="slider-track"
            :style="trackStyle"
        >
            <div
                class="filled-track"
                :style="{ width: filledTrackWidth }"
            ></div>
            <div
                class="slider-thumb"
                :style="thumbStyle"
                @mousedown="startDrag"
            ></div>
        </div>
        <div
            class="slider-value"
            :style="valueStyle"
        >{{ thumbValue }} <span v-if="this.$props.start > 20">+</span></div>
        <div class="possition">
            <div
                class="slider-value-text"
                :style="textStyle"
            >{{ $t("page.tariffs.month_cost") }} {{ price }} $</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        maxValue: {
            type: [Number],
            required: true,
        },
        price: {
            type: [String, Number],
            required: true,
        },
        start: {
            type: [String, Number, Array],
            required: true,
        },
    },
    data() {
        return {
            dragging: false,
            startX: 0,
            thumbLeft: 0,
            minValue: 0,
            trackWidth: 1110,
            notchesNumb: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        };
    },
    computed: {
        textStyle() {

            if (this.thumbValue > 1 && this.thumbValue < 20) {
                return `left: ${this.thumbLeft - 45}px;`;
            }
            if (this.thumbValue >= 19) {
                return `left: ${this.thumbLeft - 85}px;`;
            } else {
                return `left: -22px;`;
            }

        },
        trackStyle() {
            return ` height: 10px; border-radius: 7px; background-color: white; position: relative;`;
        },
        thumbStyle() {
            const thumbLeftPosition = Math.min(this.thumbLeft, this.trackWidth - 11);
            return `left: ${thumbLeftPosition}px; width: 29px;`;
        },
        valueStyle() {
            const leftPosition = Math.min(this.thumbLeft - 22, this.trackWidth - 45);
            return `left: ${Math.max(0, leftPosition)}px; min-width: 45px; max-width: 45px;`;
        },
        thumbValue() {
            const range = this.maxValue - this.minValue;
            const value =
                Math.round((this.thumbLeft / this.trackWidth) * range) +
                this.minValue;

            return this.closestValidValue(value);

        },
        filledTrackWidth() {
            const thumbPosition = (this.thumbLeft / this.trackWidth) * 100;
            return `${thumbPosition}%`;
        },
    },
    methods: {
        updateTrackWidth() {
            if (this.$refs.slider) {
                this.trackWidth = this.$refs.slider.offsetWidth;
            }
        },
        updateThumbValue() {
            this.$emit("thumbValueChanged", this.thumbValue, this.sliderType);
        },
        startDrag(event) {

            this.dragging = true;
            this.startX = event.clientX - this.thumbLeft;
            document.addEventListener("mousemove", this.handleDrag);
            document.addEventListener("mouseup", this.endDrag);
        },
        handleDrag(event) {
            if (this.dragging) {
                const newLeft = event.clientX - this.startX;
                this.thumbLeft = Math.max(1,
                    Math.min(this.trackWidth, newLeft)
                );
                this.updateThumbValue();
            }
        },
        endDrag() {
            this.dragging = false;
            document.removeEventListener("mousemove", this.handleDrag);
            document.removeEventListener("mouseup", this.endDrag);
        },
        closestValidValue(value) {
            return this.notchesNumb.reduce((closest, notch) => {
                return Math.abs(notch - value) < Math.abs(closest - value)
                    ? notch
                    : closest;
            });
        },
    },
    watch: {
        start(newStart) {

            if (newStart === "" || newStart < 0) {
                this.thumbLeft =
                    ((1 - this.minValue) / (this.maxValue - this.minValue)) *
                    this.trackWidth;
            } else {
                // Установите thumbLeft в максимальное значение, если newStart больше 20
                if (parseFloat(newStart) > 20) {
                    this.thumbLeft = this.trackWidth;
                } else {
                    this.thumbLeft =
                        ((newStart - this.minValue) /
                            (this.maxValue - this.minValue)) *
                        this.trackWidth;
                }
            }

            // Обновите значение thumbValue

        },
    },
    mounted() {
        this.updateTrackWidth(); // Инициализация значения
        window.addEventListener('resize', this.updateTrackWidth);
        this.thumbLeft = 0
        // ((this.start - this.minValue) / (this.maxValue - this.minValue)) *
        // this.trackWidth;
    },
    created() {
        // this.updateTrackWidth(); // Инициализация значения
        // window.addEventListener('resize', this.updateTrackWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateTrackWidth);
    }
};
</script>

<style scoped>
.possition {
    width: 100%;
    display: flex;
    justify-content: center;
}

.filled-track {
    height: 100%;
    border-radius: 7px;
    background-color: #7a70df;
    position: absolute;
    top: 0;
    left: 0;
}

.slider-value-text {
    margin-top: 20px;
    border-radius: 50%;
    position: absolute;
    cursor: grab;
    text-align: center;
    width: 95px;
    font-size: 12px;
    line-height: 18px;
    font-family: "Gilroy";
    font-weight: 500;
}

.slider {
    width: 100%;
    height: 30px;
    position: relative;
    display: flex;
    flex-direction: column;

}

.slider-track {
    position: relative;
    background-color: var(--block-color);

}

.slider-thumb {
    margin-top: -9px;
    width: 29px;
    height: 29px;
    background-color: white;
    border: 9px solid #7a70df;
    border-radius: 50%;
    position: absolute;
    cursor: grab;
    transform: translateX(-50%);
}

.slider-value {
    font-family: "Gilroy";
    font-weight: 500;
    text-align: center;
    position: absolute;
    border-radius: 6px;
    top: -48px;
    width: 45px;
    height: 30px;
    padding-top: 5px;
    font-size: 18px;
}

@media screen and (max-width: 480px) {
    .slider-thumb {
        min-width: 35px;
        width: 35px;
        height: 35px;
        border: 11px solid #7a70df;
        margin-top: -12px;
    }

    .slider-track {
        margin-left: 8px;
    }
}
</style>
